/**
 * Máscara de CPF e CNPJ.
 *
 * Os dois são guardados só com números — é assim que o IFLEX grava em
 * cpfcli_fin e em cpf_cli/cnpj_cli — e o formato existe só para a leitura na
 * tela. Qual dos dois aplicar sai da quantidade de dígitos: até 11 é CPF, daí
 * para cima é CNPJ.
 */
export function soDigitos(texto: string): string {
  return (texto ?? '').replace(/\D/g, '');
}

export function formataDocumento(texto: string): string {
  const digitos = soDigitos(texto);
  if (digitos === '') return '';

  if (digitos.length <= 11) {
    // Formata enquanto se digita: cada grupo só aparece quando há dígito nele.
    return digitos
      .slice(0, 11)
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
  }

  return digitos
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}
